// @systeme: contrat
// Le résultat d'une vérification de quota. Le dépassement ne bloque jamais (DEC-007) :
// c'est au consommateur de dégrader proprement.
import { z } from 'zod';
import { SchemaTypeQuota } from '../enumerations.js';
export const DecisionsQuota = ['AUTORISE', 'SEUIL_ATTEINT', 'DEPASSE'];
export const SchemaDecisionQuota = z.enum(DecisionsQuota);
export const SchemaEtatQuota = z.object({
    type: SchemaTypeQuota,
    decision: SchemaDecisionQuota,
    utilise: z.number().int().min(0),
    limite: z.number().int().min(0),
    restant: z.number().int().min(0),
    /** La période AAAA-MM concernée, en Europe/Paris. */
    periode: z.string().regex(/^\d{4}-\d{2}$/),
    /**
     * Pourquoi c'est dépassé : le quota du mois, l'abonnement (essai fini, impayé, résilié),
     * l'adresse pas encore confirmée, ou le plafond de dépense du jour (tous foyers).
     */
    raison: z.enum(['quota', 'abonnement', 'courriel', 'plafond']).optional(),
});
//# sourceMappingURL=quotas.js.map